import {
  applyMiddleware,
  compose,
  createStore,
  Middleware,
  Store
} from 'redux';
import { logger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import { IAccessManagementState } from './ducks/access-management/types';
import { IContractsAndConstructionsState } from './ducks/contracts-and-constructions/types';
import { ICreditLimitsState } from './ducks/credit-limits/types';
import { CustomersState } from './ducks/customers/types';
import { IDashboardState } from './ducks/dashboard/types';
import { IDownloadAreaState } from './ducks/download-area/types';
import { IFabricationContractState } from './ducks/fabrication-contracts/types';
import { IFabricationMockupsState } from './ducks/fabrication-mockups/types';
import { IFabricationOrdersState } from './ducks/fabrication-orders/types';
import { IFabricationProjectsState } from './ducks/fabrication-projects/types';
import { IFabricationPurchaseOrderState } from './ducks/fabrication-purchase-order/types';
import { IFabricationState } from './ducks/fabrication/types';
import { InvoicesState } from './ducks/invoices/types';
import { IManifestationsState } from './ducks/manifestations/types';
import { ILongSteelOrderItemSearchState } from './ducks/long-steel-order-item-search/types';
import { ILongSteelOrdersState } from './ducks/long-steel-orders/types';
import { INewLongSteelOrdersState } from './ducks/new-long-steel-orders/types';
import { ILongSteelShoppingCartState } from './ducks/long-steel-shopping-cart/types';
import { INotificationsState } from './ducks/notifications/types';
import { IObservalibilityState } from './ducks/observability/types';
import reducers from './ducks/rootReducer';
import sagas from './ducks/rootSaga';
import { IToastState } from './ducks/toast/types';
import { IUserState } from './ducks/user/types';
import { ILoyaltyState } from './ducks/loyalty/types';

import { IOrderSimulateState } from './ducks/order-simulate-checkout-mvp/types';
import { UpdateCartQuantityAction } from './ducks/cart-items-mvp/types';
import { IAuthState } from './ducks/auth/types';
import { IHelpCenter } from './ducks/help-center/types';
import { CrossSellItemsState } from './ducks/cross-sell/types';
import { IEntryOrderReceivers } from './ducks/entry-order/types';
import { NewLongSteelOrdersOnboardingState } from './ducks/new-long-steel-onboarding/types';
import { ConnectivityState } from './ducks/connectivity/reducer';
import { AbandonedCartState } from './ducks/abandoned-cart/types';
export interface ApplicationState {
  auth: IAuthState;
  user: IUserState;
  acessManagement: IAccessManagementState;
  customers: CustomersState;
  notifications: INotificationsState;
  dashboard: IDashboardState;
  downloadArea: IDownloadAreaState;
  longSteelOrders: ILongSteelOrdersState;
  newLongSteelOrders: INewLongSteelOrdersState;
  invoices: InvoicesState;
  manifestations: IManifestationsState;
  crossSell: CrossSellItemsState;
  helpCenter: IHelpCenter;
  creditLimits: ICreditLimitsState;
  longSteelOrderItemSearch: ILongSteelOrderItemSearchState;
  longSteelShoppingCart: ILongSteelShoppingCartState;
  loyalty: ILoyaltyState;
  fabrication: IFabricationState;
  fabricationPurchaseOrder: IFabricationPurchaseOrderState;
  contractsAndConstructions: IContractsAndConstructionsState;
  fabricationContracts: IFabricationContractState;
  fabricationMockups: IFabricationMockupsState;
  fabricationProjects: IFabricationProjectsState;
  fabricationOrders: IFabricationOrdersState;
  observability: IObservalibilityState;
  toastMessages: IToastState;
  orderSimulateCheckoutMvp: IOrderSimulateState;
  cartItemsMvp: UpdateCartQuantityAction;
  openModalPriority: number[];
  entryOrderReceivers?: IEntryOrderReceivers;
  newLongSteelOnboarding: NewLongSteelOrdersOnboardingState;
  connectivity: ConnectivityState;
  abandonedCart: AbandonedCartState;
}

const composeEnhancers =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const sagaMiddleware = createSagaMiddleware();

let middlewares = [];

if (process.env.REACT_APP_BASE_URL !== 'prod') {
  middlewares = [
    sagaMiddleware,
    logger as Middleware<object, ApplicationState>
  ];
} else {
  middlewares = [sagaMiddleware];
}

const store: Store<ApplicationState> = createStore(
  reducers,
  composeEnhancers(applyMiddleware(...middlewares))
);

sagaMiddleware.run(sagas);

export default store;
